import { render, staticRenderFns } from "./oppose-lobby.vue?vue&type=template&id=3e51132f"
import script from "./oppose-lobby.vue?vue&type=script&lang=js"
export * from "./oppose-lobby.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports